import * as actionTypes from '../actions/actionTypes'

const initialState = {
  loading: false,
  error: null,
  language: 'en',
}

export const app = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.APP_LOADING:
      return { ...state, loading: true, error: null }
    case actionTypes.APP_SUCCESS:
      return { ...state,loading: false, error: null }
    case actionTypes.APP_ERROR:
      return { ...state, loading: false, error: action.payload }
    case actionTypes.SET_LANGUAGE:
      return { ...state, language: action.payload }
    default:
      return state
  }
}
